import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { init as mainTheme } from './themes/main';
import { FolderWsWidget as mainModule } from './main';
import * as $ from 'jquery';

declare var require: any;
require('../sass-main/pdc-widget-folder-ws.sass');

import { ActionDescriptions } from '../../../_common/platform/ts/WidgetBaseModule';

export class FolderWsWidget extends WidgetBase {
    public static _name: string = 'Workspace Selector';
    public static moduleName: string = 'pdc-widget-folder-ws';
    public static icon: string = 'folder-open';
    public static themeModule = mainTheme;

    public static actions: ActionDescriptions = [
        {
            id: 'workspace-navigate',
            title: 'Workspace Navigate'
        }
    ];

    public static load() {
        var def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                var module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-folder-ws'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        values['themeNodeIdToExpand'] = 'widget-folder-ws'; //VR: WI80078
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(FolderWsWidget);
